function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createSelector, createStructuredSelector } from 'reselect';
import { isSuperSpeedProductionOption } from 'swag-common/utils/product/product.utils';
import { EMBELLISHMENT_METHODS } from 'swag-common/constants/product.constants';
import { featureTogglesSelector } from 'swag-client-common/redux/feature-toggles/feature-toggles.selectors';
import { isLoggedInSelector } from '../user/user.selectors';
import { isCuratedBrandStoreSelector } from '../curated-brand-store/curated-brand-store-other.selector';
import { currentEmbellishmentMethodSelector, designNotesSelector, discountSelector, hasRelatedProductsSelector, isSuperSpeedCurrentProductionTimeSelector, isCustomizedBlankSelector, isFullDesignProductSelector, isLimitedEditionSelector, isOutOfStockSelector, isThereNotSelectedRelatedProductSelector, orderModeSelector, outOfStockDateSelector, productSelector, productVariantsToChooseSelector, relatedProductsSelector, selectedAssociatedProductsSelector, shouldDisplayDesignNotesSelector, shouldDisplayQuantityBlockSelector, shouldDisplayRelatedProductsBlockSelector, shouldDisplayUploadLogosSelector, showColorSectionSelector, showEmbellishmentMethodSectionSelector, showPriceBreaksSelector, sizeIndexSelector, sizeLoadedSelector, sizeSelector, splitOrderModeSelector, variantSelector, isRebuildCBSProductModeSelector, chooseMethodProductDetailsBlockHeaderSelector, isEditOfSelectedProductInCBSEditModeSelector, embellishmentMethodIdSelector, productSettingsNotBlankSelector, hasDebossedPopupBeenShownForCurrentProductSelector, currentProductSettingsSelector, hasLaserEngravedPopupBeenShownForCurrentProductSelector } from './product.selectors';
import { EMBELLISHMENT_METHOD_FORBIDDEN_WARNING } from './product.constants';
const LESizeOptionsSelector = createSelector(sizeSelector, sizeIndexSelector, isLimitedEditionSelector, isCuratedBrandStoreSelector, isRebuildCBSProductModeSelector, (size, sizeIndex, isLimitedEdition, isCuratedBrandStore, isEditCBSProductMode) => {
  if (isCuratedBrandStore) {
    return ((size === null || size === void 0 ? void 0 : size.options) || []).reduce((acc, option, i) => {
      const isActive = sizeIndex === i;
      if (isActive) {
        acc.push({
          option,
          isActive,
          isActiveLE: false
        });
      }
      return acc;
    }, []);
  }
  return ((size === null || size === void 0 ? void 0 : size.options) || []).map((option, i) => {
    const isActive = sizeIndex === i;
    const isActiveLE = isActive && isLimitedEdition;
    const isDisabled = isEditCBSProductMode ? !isActive : false;
    return {
      option,
      isActive,
      isActiveLE,
      isDisabled
    };
  });
});
export const LEEmbellishmentMethodsSelector = createSelector(productSettingsNotBlankSelector, embellishmentMethodIdSelector, isLimitedEditionSelector, isSuperSpeedCurrentProductionTimeSelector, isCuratedBrandStoreSelector, (productSettings, embellishmentMethodId, isLimitedEdition, isSuperSpeedCurrentProductionTime, isCuratedBrandStore) => {
  if (isCuratedBrandStore) {
    return productSettings.reduce((acc, settings) => {
      const isActive = settings.embellishmentMethodId === embellishmentMethodId;
      if (isActive) {
        acc.push(_objectSpread({}, settings.embellishmentMethod, {
          isActive: false,
          isActiveLE: false,
          isDisabled: true
        }));
      }
      return acc;
    }, []);
  }
  return productSettings.map(settings => {
    const isActive = settings.embellishmentMethodId === embellishmentMethodId;
    const isActiveLE = isActive && isLimitedEdition;
    const isDisabled = isSuperSpeedCurrentProductionTime && !settings.productionTimeList.some(isSuperSpeedProductionOption);
    return _objectSpread({}, settings.embellishmentMethod, {
      isActive,
      isActiveLE,
      isDisabled
    });
  });
});
const LEProductVariantsToChooseSelector = createSelector(productVariantsToChooseSelector, variantSelector, isLimitedEditionSelector, isRebuildCBSProductModeSelector, (productVariantsToChoose, variant, isLimitedEdition, isEditCBSProductMode) => {
  return productVariantsToChoose.map(productVariant => {
    const isActive = (variant === null || variant === void 0 ? void 0 : variant.name) === productVariant.name;
    const isActiveLE = isActive && isLimitedEdition;
    const isDisabled = isEditCBSProductMode ? !isActive : false;
    return _objectSpread({}, productVariant, {
      isActive,
      isActiveLE,
      isDisabled
    });
  });
});
const embellishmentMethodSelector = createSelector(currentEmbellishmentMethodSelector, isEditOfSelectedProductInCBSEditModeSelector, (method, isEdit) => isEdit ? _objectSpread({}, method, {
  tooltip: EMBELLISHMENT_METHOD_FORBIDDEN_WARNING,
  isDisabled: true
}) : method);
export const selectShouldOpenDebossedPopup = createSelector(LEEmbellishmentMethodsSelector, hasDebossedPopupBeenShownForCurrentProductSelector, (_, props) => {
  var _props$method;
  return (props === null || props === void 0 ? void 0 : (_props$method = props.method) === null || _props$method === void 0 ? void 0 : _props$method.name) || '';
}, (embellishmentMethods, hasEmbossedPopupBeenShown, methodName) => methodName === EMBELLISHMENT_METHODS.DEBOSSED && !hasEmbossedPopupBeenShown && embellishmentMethods.length > 1);
export const disabledTemplateButtonSelector = createSelector(featureTogglesSelector, currentProductSettingsSelector, ({
  dynamicQuantityAndLocationsOptionsForDecorationMethods
}, currentSettings) => {
  if (!dynamicQuantityAndLocationsOptionsForDecorationMethods) {
    return '';
  }
  if (!currentSettings) {
    return 'Please select decoration method to be able to download template.';
  }
  return !currentSettings.imprintAreaTemplate ? 'This decoration method does not have template.' : '';
});
export const selectShouldOpenLaserEngravedPopup = createSelector(LEEmbellishmentMethodsSelector, hasLaserEngravedPopupBeenShownForCurrentProductSelector, (_, props) => {
  var _props$method2;
  return (props === null || props === void 0 ? void 0 : (_props$method2 = props.method) === null || _props$method2 === void 0 ? void 0 : _props$method2.name) || '';
}, (embellishmentMethods, hasLaserEngravedPopupBeenShown, methodName) => methodName === EMBELLISHMENT_METHODS.LASER_ENGRAVE && !hasLaserEngravedPopupBeenShown && embellishmentMethods.length > 1);
export const detailsSelector = createStructuredSelector({
  showPriceBreaks: showPriceBreaksSelector,
  splitOrderMode: splitOrderModeSelector,
  isFullDesignProduct: isFullDesignProductSelector,
  designNotes: designNotesSelector,
  showColorSection: showColorSectionSelector,
  isCustomizedBlank: isCustomizedBlankSelector,
  isOutOfStock: isOutOfStockSelector,
  outOfStockDate: outOfStockDateSelector,
  product: productSelector,
  embellishmentMethods: LEEmbellishmentMethodsSelector,
  embellishmentMethod: embellishmentMethodSelector,
  sizeOptions: LESizeOptionsSelector,
  shouldDisplayQuantityBlock: shouldDisplayQuantityBlockSelector,
  sizeLoaded: sizeLoadedSelector,
  discount: discountSelector,
  showEmbellishmentMethodSection: showEmbellishmentMethodSectionSelector,
  shouldDisplayUploadLogos: shouldDisplayUploadLogosSelector,
  shouldDisplayDesignNotes: shouldDisplayDesignNotesSelector,
  hasRelatedProducts: hasRelatedProductsSelector,
  fetchedAssociatedProducts: relatedProductsSelector,
  selectedAssociatedProducts: selectedAssociatedProductsSelector,
  isThereNotSelectedRelatedProduct: isThereNotSelectedRelatedProductSelector,
  builderPageMode: orderModeSelector,
  shouldDisplayRelatedProductsBlock: shouldDisplayRelatedProductsBlockSelector,
  productVariantsToChoose: LEProductVariantsToChooseSelector,
  isLimitedEdition: isLimitedEditionSelector,
  isLoggedIn: isLoggedInSelector,
  isCuratedBrandStore: isCuratedBrandStoreSelector,
  chooseMethodProductDetailsBlockHeader: chooseMethodProductDetailsBlockHeaderSelector
});